import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/WalkInto',
    name: 'WalkInto',
    component: () => import('../views/WalkInto.vue')
  },
  {
    path: '/CoreBusiness',
    name: 'CoreBusiness',
    component: () => import('../views/CoreBusiness.vue')
  },
  {
    path: '/Case',
    name: 'Case',
    component: () => import('../views/Case.vue')
  },

  {
    path: '/Link',
    name: 'Link',
    component: () => import('../views/Link.vue')
  },
  {
    path: '/CaseDetail',
    name: 'CaseDetail',
    component: () => import('../views/CaseDetail.vue')
  },
  {
    path: '/CoreBusinessDetail',
    name: 'CoreBusinessDetail',
    component: () => import('../views/CoreBusinessDetail.vue')
  },
  {
    path: '/NewsDetail',
    name: 'NewsDetail',
    component: () => import('../views/news/NewsDetail.vue')
  },
  {
    path: '/NewsSearch',
    name: 'NewsSearch',
    component: () => import('../views/NewsSearch.vue')
  },
  {
    path: '/joinTanjian',
    name: 'joinTanjian',
    component: () => import('../views/joinTanjian.vue')
  },







  // =========================================
  {//企业介绍
    path: '/companyProfile',
    name: 'companyProfile',
    component: () => import('../views/aboutUs/companyProfile.vue')
  },
  {//荣誉资质
    path: '/honorAndQualification',
    name: 'honorAndQualification',
    component: () => import('../views/aboutUs/honorAndQualification.vue')
  },
  {//客户伙伴
    path: '/customerPartner',
    name: 'customerPartner',
    component: () => import('../views/aboutUs/customerPartner.vue')
  },
  {//品牌故事
    path: '/brandStory',
    name: 'brandStory',
    component: () => import('../views/aboutUs/brandStory.vue')
  },
  {//发展历程
    path: '/developmentHistory',
    name: 'developmentHistory',
    component: () => import('../views/aboutUs/developmentHistory.vue')
  },
  {//联系我们
    path: '/linkUs',
    name: 'linkUs',
    component: () => import('../views/aboutUs/linkUs.vue')
  },
  {//加入我们
    path: '/JoinUs',
    name: 'JoinUs',
    component: () => import('../views/staffDevelopment/joinUs.vue')
  },
  {//工作在探见
    path: '/workInTanjian',
    name: 'workInTanjian',
    component: () => import('../views/staffDevelopment/workInTanjian.vue')
  },
  {//为什么选择探见
    path: '/choeseTanjian',
    name: 'choeseTanjian',
    component: () => import('../views/staffDevelopment/choeseTanjian.vue')
  },
  {//探见要闻
    path: '/news',
    name: 'news',
    component: () => import('../views/news/news.vue')
  },
  {//门窗工程
    path: '/doorsWindows',
    name: 'doorsWindows',
    component: () => import('../views/businessCase/doorsWindows.vue')
  },
  {//幕墙工程
    path: '/curtainWall',
    name: 'curtainWall',
    component: () => import('../views/businessCase/curtainWall.vue')
  },
  {//装饰装修
    path: '/decoration',
    name: 'decoration',
    component: () => import('../views/businessCase/decoration.vue')
  },
  {//智能门窗
    path: 'smartDoorsWindows',
    name: 'smartDoorsWindows',
    component: () => import('../views/businessCase/smartDoorsWindows.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {//锚点定位
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 0 }
      }
    }
  }
})

export default router
